import { getStore } from '../redux/store' 
import { showPlanBroadcast } from '../redux/broadcasts/actions'


const store = getStore()

otuApp.broadcast = {
  showPlanBroadcast : ( options ) => store.dispatch( showPlanBroadcast( options ) ),
}